import React, { useState, useEffect } from 'react';
import './App.css';

// コンポーネントのインポート
import TeamManagement from './components/TeamManagement';
import AsymmetricMatches from './components/AsymmetricMatches';
import TeamStatistics from './components/TeamStatistics';

function App() {
  const [currentTab, setCurrentTab] = useState('teams');
  const [teams, setTeams] = useState([]);
  const [asymmetricResults, setAsymmetricResults] = useState([]);
  const [tournaments, setTournaments] = useState([]);
  const [currentTournament, setCurrentTournament] = useState(null);

  // ローカルストレージからデータを読み込み
  useEffect(() => {
    const savedTeams = localStorage.getItem('tournament-teams');
    const savedAsymmetric = localStorage.getItem('tournament-asymmetric');
    const savedTournaments = localStorage.getItem('tournaments');
    const savedCurrentTournament = localStorage.getItem('current-tournament');

    if (savedTeams) {
      setTeams(JSON.parse(savedTeams));
    }
    if (savedAsymmetric) {
      setAsymmetricResults(JSON.parse(savedAsymmetric));
    }
    if (savedTournaments) {
      setTournaments(JSON.parse(savedTournaments));
    }
    if (savedCurrentTournament) {
      setCurrentTournament(JSON.parse(savedCurrentTournament));
    }
  }, []);

  // データをローカルストレージに保存
  useEffect(() => {
    localStorage.setItem('tournament-teams', JSON.stringify(teams));
  }, [teams]);

  useEffect(() => {
    localStorage.setItem('tournament-asymmetric', JSON.stringify(asymmetricResults));
  }, [asymmetricResults]);

  useEffect(() => {
    localStorage.setItem('tournaments', JSON.stringify(tournaments));
  }, [tournaments]);

  useEffect(() => {
    localStorage.setItem('current-tournament', JSON.stringify(currentTournament));
  }, [currentTournament]);

  const tabs = [
    { id: 'teams', label: 'チーム管理', icon: '👥' },
    { id: 'asymmetric', label: '総当たり戦', icon: '⚔️' },
    { id: 'statistics', label: 'チーム成績・統計', icon: '📊' }
  ];

  const renderContent = () => {
    switch (currentTab) {
      case 'teams':
        return (
          <TeamManagement 
            teams={teams} 
            setTeams={setTeams}
            tournaments={tournaments}
            setTournaments={setTournaments}
            currentTournament={currentTournament}
            setCurrentTournament={setCurrentTournament}
          />
        );
      case 'asymmetric':
        return (
          <AsymmetricMatches 
            teams={teams} 
            results={asymmetricResults} 
            setResults={setAsymmetricResults}
            currentTournament={currentTournament}
          />
        );
      case 'statistics':
        return (
          <TeamStatistics 
            teams={teams} 
            asymmetricResults={asymmetricResults}
            currentTournament={currentTournament}
          />
        );
      default:
        return <TeamManagement teams={teams} setTeams={setTeams} />;
    }
  };

  return (
    <div className="App">
      <header className="app-header">
        <h1>🎮 第五人格プロリーグ管理システム</h1>
        <p>プロチーム対戦管理 - 前後半制</p>
        {currentTournament && (
          <div className="current-tournament">
            現在の大会: {currentTournament.name}
          </div>
        )}
      </header>

      <nav className="tab-navigation">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab-button ${currentTab === tab.id ? 'active' : ''}`}
            onClick={() => setCurrentTab(tab.id)}
          >
            <span className="tab-icon">{tab.icon}</span>
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </nav>

      <main className="main-content">
        {renderContent()}
      </main>
    </div>
  );
}

export default App;
